import BaseService from "./BaseService";

class EnterpriseService {
  static async list(data) {
    const params = BaseService.cleanQueryParams(data);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/enterprises?${queryParams}`);
  }

  static async create({ data, logo }) {
    const formData = new FormData();
    formData.append("logo", logo);

    const artifactResponse = await BaseService.callAPI(
      `/enterprises/logo`,
      "POST",
      formData,
      {},
      { contentType: "multipart/form-data" }
    );

    data.logo = artifactResponse.data.response.id;

    return await BaseService.callAPI(`/enterprises`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/enterprises/${id}`);
  }

  // A licence is never edited: a new one is added. The days are yyyy-MM-dd.
  static async addLicense({ id, startDate, endDate }) {
    return await BaseService.callAPI(`/enterprises/${id}/licenses`, "POST", {
      startDate,
      endDate,
    });
  }

  // storage is in bytes.
  static async updateEntitlements({ id, users, storage }) {
    return await BaseService.callAPI(`/enterprises/${id}/entitlements`, "PUT", {
      users,
      storage,
    });
  }

  // action is "activate" or "deactivate".
  static async setActive({ id, action }) {
    return await BaseService.callAPI(`/enterprises/${id}/${action}`, "PUT");
  }

  static async selfEnterpriseUpdate(data) {
    return await BaseService.callAPI(`/enterprise`, "POST", data);
  }

  static async selfEnterpriseSMTPDetails() {
    return await BaseService.callAPI(`/enterprise/smtp`);
  }

  static async selfEmailBannerDetails() {
    return await BaseService.callAPI(`/enterprise/email/banners`);
  }

  static async selfEmailBannerUpdateDetails(data) {
    return await BaseService.callAPI(`/enterprise/email/banners`, "POST", data);
  }

  static async selfEnterpriseSMTPUpdate(data) {
    return await BaseService.callAPI(`/enterprise/smtp`, "POST", data);
  }

  static async selfEnterpriseSMTPReset() {
    return await BaseService.callAPI(`/enterprise/smtp/reset`, "POST");
  }

  // Sends a test email to the signed-in user with the saved SMTP settings,
  // or the default ones when none are saved
  static async selfEnterpriseSMTPTest() {
    return await BaseService.callAPI(`/enterprise/smtp/test`, "POST");
  }

  static async selfLearnerConfiguration() {
    return await BaseService.callAPI(`/enterprise/learner/configuration`);
  }

  static async selfLanguageConfiguration() {
    return await BaseService.callAPI(`/enterprise/language/configuration`);
  }

  static async updateSelfLanguageConfiguration(data) {
    return await BaseService.callAPI(
      `/enterprise/language/configuration`,
      "POST",
      data
    );
  }

  static async updateSelfLearnerConfiguration(data) {
    return await BaseService.callAPI(
      `/enterprise/learner/configuration`,
      "POST",
      data
    );
  }

  static async getDomainDetails(subdomain) {
    return await BaseService.callAPI(
      `/domain?domain=${subdomain}`,
      "GET",
      null,
      null,
      null,
      true
    );
  }

  static async selfRegistrationConfiguration() {
    return await BaseService.callAPI(
      `/enterprise/self-registration/configuration`
    );
  }

  static async updateSelfRegistrationConfiguration(data) {
    return await BaseService.callAPI(
      `/enterprise/self-registration/configuration`,
      "POST",
      data
    );
  }
}

export default EnterpriseService;
